/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export enum SpaceSubModuleEnum {
  DEVELOP = 'develop',
  LIBRARY = 'library',
  KNOWLEDGE = 'knowledge',
  PROMPT_ENGINEERING = 'prompt-engineering/prompts',
  PROMPT_PLAYGROUND = 'prompt-engineering/playground',
  EVALUATION_DATASETS = 'evaluation/datasets',
  EVALUATION_EVALUATORS = 'evaluation/evaluators',
  EVALUATION_EXPERIMENTS = 'evaluation/experiments',
  MODELS = 'models',
  SKILLS = 'skills',
  HARNESS = 'harness',
  LOGS = 'logs',
  BILLING = 'billing',
  MEMBERS = 'members',
  OPERATION_LOGS = 'operation-logs',
}
